<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <div class="navbar-minimize">
        <button class="btn btn-outline btn-fill btn-round btn-icon d-none d-lg-block" @click="minimizeSidebar">
          <i :class="$sidebar.isMinimized ? 'fa fa-ellipsis-v' : 'fa fa-navicon'"></i>
        </button>
      </div>
      <button type="button"
              class="navbar-toggler navbar-toggler-right"
              :class="{toggled: $sidebar.showSidebar}"
              aria-expanded="false"
              @click="toggleSidebar">
        <!-- When sidebar is open, show an arrow -->
        <template v-if="$sidebar.showSidebar">
          <!-- replace with whatever arrow icon you’re using -->
          <i class="fas fa-arrow-left"></i>
        </template>

        <!-- When sidebar is closed, show the three burger lines -->
        <template v-else>
          <span class="navbar-toggler-bar burger-lines"></span>
          <span class="navbar-toggler-bar burger-lines"></span>
          <span class="navbar-toggler-bar burger-lines"></span>
        </template>
      </button>
      <div class="collapse navbar-collapse justify-content-end">
        <a
          href="#"
          class="nav-link d-flex align-items-center p-0"
          @click.prevent="logout"
        >
          <i class="nc-icon nc-button-power mr-2"></i>
          <span>Log out</span>
        </a>
      </div>
    </div>
  </nav>
</template>
<script>
import { useLoginStore } from "src/stores/loginStore";

export default {
  mounted() {
    this.store = useLoginStore();
  },
  data() {
    return {
      activeNotifications: false,
    };
  },
  methods: {
    logout() {
      localStorage.removeItem("jwtToken");
      this.store.$reset();
      this.$router.push({
        name: "Login",
      });
    },
    minimizeSidebar () {
      this.$sidebar.toggleMinimize()
    },
    toggleSidebar () {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
  },
};
</script>
<style scoped>
.fa-arrow-left{
  color: #000000;
}
.nc-icon {
  color: #000000;
}
.navbar {
  background-color: #ffffff;
  border-bottom: 1px solid #000000;
}
.nav-link.d-flex {
  color: #000000 !important;
}
.nav-link.d-flex i {
  margin-right: 0.5rem;
  color: #000000;
}
.nav-link.d-flex span {
  color: #000000;
}
.navbar-minimize{
  display: none;
}
.btn-outline {
  color: #000000;
  border-color: #000000;
}
.btn-outline:hover {
  background-color: rgba(0, 0, 0, 0.1);
  color: #000000;
}
.navbar-toggler-bar {
  background-color: #000000;
}
</style>
